import { StandardEvents } from '@shopify/events';
import { prefersReducedMotion } from '@theme/utilities';

/**
 * <ott-fit-line>: keeps the fit line (blocks/ott-fit-line.liquid) on the size the shopper picks, and
 * makes its "Size chart" link open the size chart panel (blocks/ott-pdp-accordion.liquid).
 */
class OttFitLine extends HTMLElement {
  /** @type {AbortController | undefined} */
  #controller;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    this.closest('.shopify-section, dialog')?.addEventListener(
      StandardEvents.productSelect,
      this.#handleProductSelect,
      { signal }
    );
    this.addEventListener('click', this.#handleClick, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  /** @param {Event & {selectedOptions?: {name: string, value: string}[]}} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const optionName = (this.dataset.optionName || 'size').toLowerCase();
    const size = event.selectedOptions?.find((option) => option.name.toLowerCase() === optionName)?.value;
    if (!size) return;

    /** @type {Record<string, string>} */
    const lines = JSON.parse(this.querySelector('[data-ott-fit-lines]')?.textContent || '{}');
    const text = this.querySelector('[data-ott-fit-text]');
    if (text && lines[size]) text.textContent = lines[size];
  };

  /** @param {MouseEvent} event */
  #handleClick = (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-ott-open-chart]');
    if (!link) return;

    const chart = document.getElementById('ott-size-chart');
    const panel = chart?.closest('details');
    if (!chart || !panel) return;

    event.preventDefault();
    panel.open = true;
    panel.querySelector('summary')?.focus({ preventScroll: true });
    panel.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
  };
}

if (!customElements.get('ott-fit-line')) customElements.define('ott-fit-line', OttFitLine);
